module.exports = __webpack_public_path__ + "static/media/twitter-clone.d627bc00.webp";